export function minifyAddress(address: string, len = 4) {
  const isEthereumAddress = address?.startsWith("0x");
  return `${address?.slice(
    0,
    (isEthereumAddress ? 2 : 0) + len
  )}...${address?.slice(-len)}`;
}
